import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import { IndexContext } from "../lib/IndexContext.js";
import { InstantSearchContext } from "../lib/InstantSearchContext.js";
import { useInstantSearchApi } from "../lib/useInstantSearchApi.js";
export function InstantSearch(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var search = useInstantSearchApi(props);

  if (!search.started) {
    return null;
  }

  return /*#__PURE__*/React.createElement(InstantSearchContext.Provider, {
    value: search
  }, /*#__PURE__*/React.createElement(IndexContext.Provider, {
    value: search.mainIndex
  }, children));
}